
import { mapState } from 'vuex'
import allUrls from '@/utils/config'

export default {
  components: {},
  props: {
    content: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    okText: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalVisible: false,
      orderList: [
        {
          icon: 'enterprise_login',
          text: this.$t('serviceSupport.consigns.enterprise_login'),
          link: `${allUrls.iuopGlobalUsUrl}/#/?lang=zh-CN&gjUtm=K2%3AsfIntlOs,K3%3AsfIntlOsUsCa`,
        },
        {
          icon: 'personalUs',
          text: this.$t('serviceSupport.consigns.personalLoginUs'),
          link: allUrls.usshipwebUs,
        },
        {
          icon: 'personalCanada',
          text: this.$t('serviceSupport.consigns.personalLoginCanada'),
          link: allUrls.usshipwebCanada,
        },
      ],
    }
  },
  computed: {
    ...mapState({
      resizeInfo: (state) => state.resizeInfo,
      isMobile: (state) => state.isMobile,
    }),
  },
  methods: {
    openDialog() {
      this.modalVisible = true
    },
    handleCancel() {
      this.modalVisible = false
    },
    handleClick(item) {
      window.open(item.link)
    },
    handleOk() {
      this.modalVisible = false
      this.$emit('ok')
    },
  },
}
